export const AUTH_COMPLETION_ERROR_MESSAGE =
  'Something went wrong updating your details. Please try again.';
